module.exports = __webpack_public_path__ + "static/media/D4.7411cdf9.png";